import { Reveal } from "@/components/common/Reveal";
import { PROJECTS, TOTAL_UNITS } from "@/data/site";

const FIGURES = [
  { value: "2009", label: "Founded by Shane O'Reilly" },
  { value: `${Math.floor(TOTAL_UNITS / 10) * 10}+`, label: "Homes fitted out across our listed schemes" },
  { value: String(PROJECTS.length), label: "Schemes in our project portfolio" },
  { value: "Dublin", label: "& surrounding counties" },
];

export const KeyFigures = () => (
  <section className="border-y border-canvas-line bg-canvas-800" data-testid="key-figures">
    <div className="mx-auto grid max-w-7xl grid-cols-2 lg:grid-cols-4">
      {FIGURES.map((f, i) => (
        <Reveal key={f.label} delay={i * 0.08} className={`border-canvas-line px-5 py-10 sm:px-8 sm:py-12 ${i % 2 === 0 ? "border-r" : ""} ${i < 2 ? "border-b lg:border-b-0" : ""} ${i === 1 ? "lg:border-r" : ""}`}>
          <span className="label-mono text-steel">F/{String(i + 1).padStart(2, "0")}</span>
          <p className="mt-4 font-display text-5xl font-extrabold uppercase leading-none text-ink sm:text-6xl" data-testid={`figure-value-${i}`}>{f.value}</p>
          <p className="mt-3 max-w-[14rem] text-sm text-steel">{f.label}</p>
        </Reveal>
      ))}
    </div>
  </section>
);
